import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { distinctUntilChanged, takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/components/base.component';

@Component({
    selector: 'lex-manage-password-requirements',
    templateUrl: './manage-password-requirements.component.html',
    styleUrls: ['./manage-password-requirements.component.scss'],
    standalone: false
})
export class ManagePasswordRequirementsComponent extends BaseComponent implements OnInit {

    @Input() newPasswordControl: AbstractControl;
    @Input() confirmPasswordControl: AbstractControl;
    @Input() passwordRequirementMet: boolean;
    @Output() passwordRequirementMetChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    private validators: (() => boolean)[] = [
        () => this.hasMinLength(),
        () => this.hasUpperCharacter(),
        () => this.hasLowerCharacter(),
        () => this.hasNumber(),
        () => this.hasSpecialCharacter(),
        () => this.hasMatchingPasswords()
    ]

    constructor() {
        super();
        this.passwordRequirementMetChange.emit(false);
    }

    ngOnInit(): void {
        this.newPasswordControl.valueChanges.pipe(
            distinctUntilChanged(),
            takeUntil((this.destroy$))
        ).subscribe(() => {
            if (this.validators.every(x => x()))
                this.passwordRequirementMetChange.emit(true);
        });

        this.confirmPasswordControl.valueChanges.pipe(
            distinctUntilChanged(),
            takeUntil((this.destroy$))
        ).subscribe(() => {
            if (this.validators.every(x => x()))
                this.passwordRequirementMetChange.emit(true);
        });
    }

    public hasMinLength(): boolean {
        return this.newPasswordControl.value.length >= 8;
    }

    public hasUpperCharacter(): boolean {
        //regex for password- must contain one upper case
        const upperCaseRegex = /(?=.*[A-Z])/;
        return upperCaseRegex.test(this.newPasswordControl.value);
    }

    public hasLowerCharacter(): boolean {
        //regex for password- must contain one lower case
        const lowerCaseRegex = /(?=.*[a-z])/;
        return lowerCaseRegex.test(this.newPasswordControl.value);
    }

    public hasNumber(): boolean {
        //regex for password- must contain one numeric digit
        const digitRegex = /(?=.*?[0-9])/;
        return digitRegex.test(this.newPasswordControl.value);
    }

    public hasSpecialCharacter(): boolean {
        //regex for password- must contain one special character
        const specialCharRegex = /(?=.*?[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])/;
        return specialCharRegex.test(this.newPasswordControl.value);
    }

    public hasMatchingPasswords(): boolean {
        return this.newPasswordControl.value === this.confirmPasswordControl.value
            && this.newPasswordControl.value.length > 0
            && this.confirmPasswordControl.value.length > 0;
    }

}
